import React, {useState} from "react";
import Modal from "../../../components/common/form/Modal";
import ButtonTray from "../../../components/common/form/ButtonTray";
import TextAreaField from "../../../components/common/form/TextAreaField";
import {computeRegex, serialize} from "../../../helpers/utils/Utils";
import {useParseImportedDataMutation} from "../ordersApi";
import {handleRTKQuery} from "../../../helpers/utils/RtkQueryUtils";
import {useGetEnumsQuery} from "../../../app/globalApi";
import {getEnumDisplayNameByConstant} from "../../../helpers/utils/EnumUtils";
import {useGetAllStatesQuery} from "../../data/states/statesApi";

interface Props {
    show: boolean;
    setShow: any;
    setCreateOrderData: any;
}


const ImportData: React.FC<Props> = ({show, setShow, setCreateOrderData}) => {

    const [data, setData] = useState("");

    const [importDataApi, importDataApiResponse] = useParseImportedDataMutation();
    const {data: enums} = useGetEnumsQuery("");
    const statesApiResult = useGetAllStatesQuery("");


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (data) {
            const regex = /(\n\s*){2,}/g;
            const replacement = '\n';

            const value = data.replaceAll(regex, replacement).trim();

            const AllLines = value.substring(value.indexOf("\n") + 1).split("\n").filter(line => line !== '');

            const linesWithApplesOranges = AllLines.filter(line => line.includes('Send Tax and HOA Certs to'));

            const linesWithoutApplesOranges = AllLines.filter(line => !line.includes('Send Tax and HOA Certs to'));

            const result = [...linesWithoutApplesOranges, ...linesWithApplesOranges].join("\n");

            const formattedParagraph = result.replace(computeRegex(result), "\n\n$1");

            let params = serialize({importData: formattedParagraph});

            await handleRTKQuery(
                () => importDataApi(params).unwrap(),
                (data: any) => {
                    if (data?.errorCode === 200) {

                        const updatedOrderRequest = {
                            ...data?.orderRequest.orderRequest,
                            properties: data?.orderRequest?.orderRequest?.properties?.map((property: any) => ({
                                ...property,
                                propertyType: {
                                    label: getEnumDisplayNameByConstant(enums?.["PropertyType"], property.propertyType), // You can customize this label as needed
                                    value: property.propertyType
                                },
                                countyName:{
                                    value: property?.countyName,
                                    label:property?.countyName,
                                },
                                address: {
                                    ...property.address,
                                    state: property?.address?.state ? {
                                        value: property?.address?.state,
                                        label: statesApiResult?.data.filter((el: any) => el.stateAbbreviation == property?.address?.state)[0].stateName
                                    } : null
                                }
                            }))
                        };

                        setCreateOrderData(updatedOrderRequest);
                        setShow(false);

                    }
                }
            );
        }
    }


    return (
        <>
            <Modal
                title={"Import Data"}
                show={show}
                setShow={setShow}
                className="w-2/5  bg-text-0 rounded-lg shadow-lg"
                fields={
                    <>
                        <div className="modal-body mb-3 p-3">
                            <TextAreaField
                                name="description"
                                onChange={(e) => setData(e.target.value)}
                                value={data || ""}
                                placeholder="Enter Description..."
                                rows={5}
                                hidelabel={true}
                            />
                        </div>
                        <div className="mt-4 border-t border-t-surface-5 flex justify-end">
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            type: "submit",
                                            onClick: handleSubmit,
                                            isLoading: importDataApiResponse.isLoading,
                                        },
                                        buttonType: "button",
                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />

                        </div>
                    </>
                }
            />
        </>
    )
}
export default ImportData;